import type { ISkillData } from '../types';
import type { ISkillMdContent } from '../types/skillDetail';

/**
 * 按语言获取 Skill 正文（直接读取 zh_md / en_md 字段，不再解析 zip）
 * 英文环境优先 en_md，为空时 fallback 中文 zh_md；zh_md / en_md 均为空时返回 null
 * @param skill - Skill 原始数据
 * @param isEN - 是否英文环境
 */
export const getSkillMdContent = (
  skill: ISkillData,
  isEN: boolean,
): ISkillMdContent | null => {
  const content = (isEN ? skill.en_md : skill.zh_md) || skill.zh_md;
  return content ? { content } : null;
};

/**
 * 格式化文件大小展示
 * @param bytes - 字节数
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  return `${(bytes / 1024).toFixed(1)} KB`;
};
